// Printing uses the server PDF, so acknowledge the exact form snapshot first.
export function buildPrintGuard(form, { sync = () => {}, getSections = () => [], onStatus = () => {} } = {}) {
  sync()
  const snapshot = () => JSON.stringify(Array.from(new FormData(form).entries()).filter(([name]) => !['authenticity_token', 'utf8'].includes(name)))
  let savedSnapshot = form ? snapshot() : null
  let saving = false
  let disposed = false
  const pendingRequests = new Set()
  const pauseOrdinarySave = event => {
    if (!saving) return
    event.preventDefault()
    clearTimeout(window.failedSave)
    delete window._lastAutoSavedBody
  }
  const trackRequest = event => {
    pendingRequests.add(event.detail[0])
    savedSnapshot = null
  }
  const finishRequest = event => pendingRequests.delete(event.detail[0])
  if (form) {
    form.addEventListener('ajax:before', pauseOrdinarySave)
    form.addEventListener('ajax:send', trackRequest)
    form.addEventListener('ajax:complete', finishRequest)
  }
  const status = message => { if (!disposed) onStatus(message) }

  const sectionsSaved = () => getSections().every(section => !section._savePromise && section.bodyFieldTarget.value === section._lastSavedBody)

  async function save() {
    saving = true
    status('Saving changes. Please wait before printing.')
    try {
      const sectionSaves = getSections().map(section => section.saveSection())
      const currentSnapshot = form ? snapshot() : null
      if (form && currentSnapshot !== savedSnapshot) {
        const response = await fetch(form.action, {
          method: (form.method || 'post').toUpperCase(),
          headers: { 'Accept': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '' },
          body: new FormData(form),
          credentials: 'same-origin',
        })
        if (!response.ok || (await response.json()).success !== true) throw new Error('Post save failed')
        savedSnapshot = currentSnapshot
      }
      await Promise.all(sectionSaves)
      sync()
      if (!sectionsSaved()) throw new Error('Section save failed')
      status(!form || snapshot() === savedSnapshot ? 'Changes saved. Click Print again.' : 'More changes need saving. Click Print again.')
    } catch (_) {
      status('Changes could not be saved. Click Print to retry before printing.')
    } finally {
      saving = false
    }
  }

  return {
    check() {
      sync()
      if (pendingRequests.size) { status('Waiting for the current save. Click Print again when it finishes.'); return false }
      if (saving) { status('Saving changes. Please wait before printing.'); return false }
      if ((form && snapshot() !== savedSnapshot) || !sectionsSaved()) { save(); return false }
      status('')
      return true
    },
    destroy() {
      disposed = true
      if (form) {
        form.removeEventListener('ajax:before', pauseOrdinarySave)
        form.removeEventListener('ajax:send', trackRequest)
        form.removeEventListener('ajax:complete', finishRequest)
      }
    },
  }
}
